const candidateBlockageReason = {
    EVICTION: 'eviction',
};

export default candidateBlockageReason;
